import React from 'react';
import { useRoutes } from "react-router-dom";
import UnauthorizedRoutes from "./routes/UnauthorizedRoutes";
import { useSelector } from "./redux/store";
import AuthorizedRoutes from "./routes/AuthorizedRoutes";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { themeOptions } from "./theme/themeOptions";
import './App.css';

function App() {
    const { accessToken } = useSelector((state) => state.auth);
    
    // Rotaları birleştirip ProtectedRoute ile sarmalayabiliriz ama 
    // mevcut yapıda accessToken'a göre tüm router'ı değiştirmek de bir yöntem.
    // Yine de daha temiz bir yaklaşım için route config'lerini birleştirmek iyi olabilir.
    // Şimdilik mevcut mantığı koruyup sadece kodu sadeleştiriyorum.
    
    const routing = useRoutes(accessToken ? AuthorizedRoutes : UnauthorizedRoutes);
    const theme = createTheme(themeOptions);

    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                {routing}
            </div>
        </ThemeProvider>
    );
}

export default App;
